import {AbstractApiService} from "./AbstractApiService";
import {API_SERVICE_URL} from "navigation-common/firebase-config";
import {FileUploadContext, StorageFileResult} from "navigation-common/types/navigation-types";
import {MENU_ITEM_IMAGE_CONTEXT} from "navigation-common/types/MenuItemImageStoragePath";
import {securityService} from "navigation-common/SecurityService";
import {fromBlob} from "image-resize-compress";

export class ImageService extends AbstractApiService {

    async saveMenuItemImage(data: File, menuKey: string): Promise<StorageFileResult> {
        if (!data.name) {
            throw new Error("No filename");
        }
        return this.uploadFile(data, data.type, securityService.sanitizeFileName(data.name), menuKey, MENU_ITEM_IMAGE_CONTEXT);
    }

    private async uploadFile(data: File, contentType: string, filename: string, menuKey: string, context: FileUploadContext) {
        const formData = new FormData();
        formData.append("fileName", filename);
        formData.append("contentType", contentType);
        formData.append("filecontent", data);

        const axiosRequestConfig = this.buildJWTAuthAxiosConfig();
        axiosRequestConfig.headers["content-type"] = "application/x-www-form-urlencoded";

        return this.client
            .post(
                API_SERVICE_URL + "/storage/" + menuKey + "/" + context,
                formData,
                axiosRequestConfig
            )
            .then((result) => result.data);
    }

    async downScaleImage(file: File, width: number) {
        const resizedBlob = await fromBlob(file, 100, width, "auto");
        return new File([resizedBlob], file.name, {type: file.type});
    }
}

export const imageService = new ImageService();
